import Backbone from 'backbone'
import template from './new-form.hbs'
import appDisplay from 'scoreboard/components/app-display'
import FormView from 'scoreboard/components/form-view'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import _ from 'lodash'
import projects from 'scoreboard/projects/projects'
import ErrorView from 'scoreboard/components/error-view'
import HttpStatusCodes from 'http-status-codes'
import i18n from 'scoreboard/components/i18n'
import errorHandler from 'scoreboard/components/error-handler'


var NewForm = Backbone.View.extend({

	tagName: 'form',

	className: 'new-organization',

	initialize: function() {
		this.formView = new FormView({ el: this.el, submit: this.submit.bind(this) })
	},

	render: function() {
		this.$el.empty().append(template())

		this.labelField = new MarkedField({
			el: this.$('[name=label]'),
			validator: requiredValidator
		}).render()

		this.formView.start({
			isNew: this.model.isNew()
		})

		return this
	},

	submit: function() {
		// #22699 disable cancel button after clicking submit
		this.$('.cancel').prop('disabled', true)
		return this.model.save({
			// NOTE: If there's a pending project, the org should go in there, if not, it should
			// go in the currently active project.
			projectId: projects.pendingProjectId || projects.id,
			label: this.$('.label').val()
		},{
			success: org => {
				this.trigger('done')
				org.set('icon', 'circle')
				Backbone.trigger('add:domain-object', org, org.get('parentId'))
			},
			error: (model, xhr) => {
				errorHandler(xhr, {
					formView: this.formView,
					handler: () => {
						if (xhr.status == HttpStatusCodes.FORBIDDEN) {
							const {message} = xhr.responseJSON
							appDisplay.dialog(new ErrorView({
								title: message,
								message: i18n.get('common.security.missing.org.create')
							}))
							return true
						}
					}
				})
			}
		})
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.formView, this.labelField], 'remove')
	}

})

export default NewForm

NewForm.__filename__ = 'organizations/new-form.js'
